import normalizeString from "./normaliseString";

const fold = (value: unknown) => (value === null || value === undefined ? undefined : normalizeString(String(value)));

//The option a saved value should select, matched on the search field, the id or the value field.
//Case, spaces and accents are all ignored, so a saved "CITROEN" selects eBay's "Citroën" rather
//than leaving the box blank.
export function findInitialOption<T extends object>(options: T[], initialValue: unknown, searchField: string, valueField = ""): T | undefined {
  const searchValue = fold(initialValue);

  return options.find((option) => {
    const fields = option as Record<string, unknown>;

    return fold(fields[searchField]) === searchValue ||
      fold(fields.id) === searchValue ||
      (valueField !== "" && fold(fields[valueField]) === searchValue);
  });
}
